import React from 'react';
import { observer } from 'mobx-react';
import {
  CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar
} from 'recharts';

import styles from './widgets.module.css';
import dashboardStore from '../../../stores/dashboard.store';
import memberStore from '../../../stores/member.store';
import { statUnitLabel } from '../../../models/stat.model';
import { GraphTimeTick } from '../../common/graph_time_tick.component';
import ChartTooltip, { axisTickStyle, Coordinates } from './chart_tooltip.component';
import { deployMarkerLines } from './deploy_markers';

const AffectedChartWidget = observer(() => {
  const { affectedDevices } = dashboardStore;
  const unitLabel = statUnitLabel(memberStore.app?.platform);
  const affectedDevicesData = affectedDevices.slice();
    // linechart is checking if it is an array and it isn't because of mobx

  return (
    <div>
      <div className={styles.chartTitle}>Affected {unitLabel}:</div>
      <ResponsiveContainer width="99%" height={165}>
        <BarChart data={affectedDevicesData} syncId="dashboard">
          <Tooltip wrapperStyle={{zIndex: 100000}} content={<ChartTooltip perc={true}/>} position={{ y:85 } as Coordinates}/>
          <Bar dataKey="exception" name="Exception" fill="var(--black)" barSize={8}/>
          <Bar dataKey="error" name="Error" fill="var(--lipstick)" barSize={8}/>
          <Bar dataKey="warning" name="Warning" fill="var(--mango)" barSize={8}/>
          {deployMarkerLines(affectedDevicesData)}
          <CartesianGrid stroke="#ccc" strokeDasharray="1 1" />
          <XAxis dataKey={(stat) => stat.time.toISOString()}
            tick={<GraphTimeTick />} stroke="#21a1b5"/>
          <YAxis axisLine={false} tickLine={false} tick={axisTickStyle}
            tickFormatter={(perc: number) => `${Math.floor(perc * 100)}%`} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
});

export default AffectedChartWidget;
